import { FC } from 'react';
import { useHistory } from 'react-router';
import { Box, HStack, Image, Text, VStack } from '@chakra-ui/react';

import ChangePlanModal from 'assets/images/change-plan-modal.svg';
import { MULTI_WALLET_UPGRADE_MODAL } from 'common/upgrade/constants';
import Button from 'components/_core/Button';
import SunshineIcon from 'components/_core/SunshineIcon';
import SunshineModal from 'components/_core/SunshineModal';
import MultiWalletUpsellBadge from 'components/MultiWalletUpsellBadge';
import TrackView from 'features/Analytics/TrackView';
import * as upgradeRoutes from 'features/Upgrade/routes';

import locales from './locales';

type MultiWalletUpsellModalProps = {
  isOpen: boolean;
  onClose: () => void;
  walletLimit?: number;
};

const MultiWalletUpsellModal: FC<MultiWalletUpsellModalProps> = ({
  isOpen,
  onClose,
  walletLimit,
}) => {
  const history = useHistory();

  const hasMultiWallet = Boolean(walletLimit);

  const handleClick = () => {
    history.push({
      pathname: upgradeRoutes.choice,
      state: {
        from: MULTI_WALLET_UPGRADE_MODAL,
      },
    });
  };

  return (
    <SunshineModal isOpen={isOpen} onClose={onClose}>
      <TrackView pageName="MultiWalletUpsellModal" />
      <SunshineModal.Header />
      <Image alt="change-plan-modal" src={ChangePlanModal} />
      <SunshineModal.Body>
        {!hasMultiWallet ? (
          <Box marginBottom="space-16">
            <MultiWalletUpsellBadge />
          </Box>
        ) : null}
        <SunshineModal.Title>
          {hasMultiWallet
            ? locales.withMultiWallet.title
            : locales.withoutMultiWallet.title}
        </SunshineModal.Title>
        <VStack
          alignItems="left"
          spacing={hasMultiWallet ? 'space-24' : 'space-16'}
        >
          {!hasMultiWallet ? (
            locales.withoutMultiWallet.items.map((item, itemIndex) => (
              <HStack key={itemIndex} spacing="space-16">
                <SunshineIcon name="tick" />
                <Text color="grey.800">{item}</Text>
              </HStack>
            ))
          ) : (
            <>
              <Text color="grey.800">
                {locales.formatString(
                  walletLimit && walletLimit > 1
                    ? locales.withMultiWallet.includedWallets.plural
                    : locales.withMultiWallet.includedWallets.singular,
                  { walletLimit: walletLimit?.toString() as string },
                )}
              </Text>
              <Text color="grey.800">
                {locales.withMultiWallet.description}
              </Text>
            </>
          )}
        </VStack>
      </SunshineModal.Body>
      <SunshineModal.Footer>
        <Button icon="arrow-right" onClick={handleClick} variant="primary">
          {locales.changePlan}
        </Button>
      </SunshineModal.Footer>
    </SunshineModal>
  );
};

export default MultiWalletUpsellModal;
